import Phaser from 'phaser';
import type { GameContext } from '../types/GameContext';

export const GAME_CONTEXT_KEY = 'gameContext';

export function setGameContext(scene: Phaser.Scene, ctx: GameContext): void {
  scene.registry.set(GAME_CONTEXT_KEY, ctx);
}

export function getGameContext(scene: Phaser.Scene): GameContext {
  const ctx = scene.registry.get(GAME_CONTEXT_KEY) as GameContext | undefined;
  if (!ctx) {
    // Provide a clearer error to aid debugging when called before Scene.create publishes context
    throw new Error('GameContext not initialized on this Scene. Ensure setGameContext is called in Scene.create().');
  }
  return ctx;
}